// export const col__one = [
//                             'About Us',
//                             'Term & Condition',
//                             'Blog',
//                             'Private Policy',
//                             'Reviews',
//                             'Careers',
//                             'Contact Us'
//                         ]
export const col__one = [
        {
           name: "About Us",
           path: '/about'
        },
        {
           name: "Term & Condition",
           path: '/terms-condition'
        },
        {
           name: "Blog",
           path: '/blog'
        },
        {
           name: "Private Policy",
           path: '/policy'
        },
        {
           name: "Reviews",
           path: '/reviews'
        },
        {
           name: "Careers",
           path: '/careers'
        },
        {
           name: "Contact Us",
           path: '/contact'
        },
        
]
// export const col__two = [
//         'Mumbai',
//         'Navi Mumbai',
//         'Pune'
// ]

export const col__two = [
        {name: 'Mumbai', path: ""},
        {name: 'Navi Mumbai', path: ""},
        {name: 'Pune', path: ""}
]